export const CATEGORY_TYPE = {
  MEAL: "MEAL",
  PRODUCT: "PRODUCT",
};
export const DIETARY_PREFERENCE_TYPE = {
  VEGETARIAN: 1,
  VEGAN: 2,
  GLUTEN_FREE: 3,
  DIARY_FREE: 4,
  NUT_FREE: 5,
};
export const Variation_TYPE = {
  FLAVOUR: "1",
  COLOR: "2",
};
export const Variation_TYPE_ = {
  1: "FLAVOUR",
  2: "COLOR",
};
const ORDER_TYPE = {
  MEAL: 1,
  PRODUCT: 2,
  BOTH: 3,
};
